import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class MerchantMenuService extends Service {
    constructor() {
        super();
        this.baseURL = 'merchant/menu';
    }

    async findMenus() {
        return fetch(SERVER_URL + this.baseURL, {
            headers: {'Content-Type': 'application/json', Authorization: (await GeneralUtils.getJwtFromCookieOrTillService())}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }


}